<!-- PAGE CONTENT -->
<div id="page" class="page">
	<app-hero></app-hero>

	<app-about-us></app-about-us>

	<app-service-carousel></app-service-carousel>

	<section id="services-1" class="wide-50 services-section division d-none">
		<div class="container">
			<div class="row">


				<!-- SERVICE BOX #1 -->
				<div class="col-sm-6 col-lg-3">
					<div class="sbox-1 icon-md wow fadeInUp" data-wow-delay="0.4s"
						style="visibility: visible; animation-delay: 0.4s; animation-name: fadeInUp;">

						<!-- Icon -->
						<span class="flaticon-137-doctor blue-color"></span>

						<!-- Title -->
						<h5 class="h5-sm steelblue-color">Qualified Doctors</h5>

						<!-- Text -->
						<p>Our team of highly qualified doctors is dedicated to providing expert, 
							personalized care
						</p>

					</div>
				</div>


				<!-- SERVICE BOX #2 -->
				<div class="col-sm-6 col-lg-3">
					<div class="sbox-1 icon-md wow fadeInUp" data-wow-delay="0.6s"
						style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInUp;">

						<!-- Icon -->
						<span class="flaticon-076-microscope blue-color"></span>

						<!-- Title -->
						<h5 class="h5-sm steelblue-color">Modern Equipment</h5>

						<!-- Text -->
						<p>Porta semper lacus cursus, feugiat primis ultrice in ligula risus auctor
							tempus feugiat dolor lacinia
						</p>

					</div>
				</div>


				<!-- SERVICE BOX #3 -->
				<div class="col-sm-6 col-lg-3">
					<div class="sbox-1 icon-md wow fadeInUp" data-wow-delay="0.8s"
						style="visibility: visible; animation-delay: 0.8s; animation-name: fadeInUp;">

						<!-- Icon -->
						<span class="flaticon-008-ambulance-6 blue-color"></span>

						<!-- Title -->
						<h5 class="h5-sm steelblue-color">Emergency Help</h5>

						<!-- Text -->
						<p>Porta semper lacus cursus, feugiat primis ultrice in ligula risus auctor
							tempus feugiat dolor lacinia
						</p>

					</div>
				</div>


				<!-- SERVICE BOX #4 -->
				<div class="col-sm-6 col-lg-3">
					<div class="sbox-1 icon-md wow fadeInUp" data-wow-delay="1s"
						style="visibility: visible; animation-delay: 1s; animation-name: fadeInUp;">

						<!-- Icon -->
						<span class="flaticon-083-stethoscope blue-color"></span>

						<!-- Title -->
						<h5 class="h5-sm steelblue-color">Individual Approach</h5>

						<!-- Text -->
						<p>Porta semper lacus cursus, feugiat primis ultrice in ligula risus auctor
							tempus feugiat dolor lacinia
						</p>

					</div>
				</div>


			</div> <!-- End row -->
		</div> <!-- End container -->
	</section>

	<section id="about-6" class="pt-100 about-section division">
		<div class="container">
			<div class="row d-flex align-items-center">


				<!-- TEXT BLOCK -->
				<div class="col-lg-6">
					<div class="txt-block pc-30 wow fadeInUp" data-wow-delay="0.4s"
						style="visibility: visible; animation-delay: 0.4s; animation-name: fadeInUp;">

						<!-- Section ID -->
						<span class="section-id blue-color">Qualified Doctors</span>

						<!-- Title -->
						<h3 class="h3-md steelblue-color">Group of Certified and Experienced Doctors</h3>

						<!-- CONTENT BOX #1 -->
						<div class="box-list">
							<div class="box-list-icon"><i class="fas fa-genderless"></i></div>
							<p>Certified, skilled, and highly experienced doctors across multiple specialties
								Committed to delivering expert, ethical, and personalized healthcare
							</p>
						</div>

						<!-- CONTENT BOX #2 -->
						<div class="box-list">
							<div class="box-list-icon"><i class="fas fa-genderless"></i></div>
							<p>Our clinic is proud to have a team of certified and experienced doctors who are leaders in their fields. 
								With years of hands-on expertise
								 and a commitment to continuous learning, they provide accurate diagnosis and effective treatments
							</p>
						</div>

						<!-- Button -->
						<a href="all-doctors.html" class="btn btn-blue blue-hover mt-25">Meet The Doctors</a>

					</div>
				</div> <!-- END TEXT BLOCK -->


				<!-- IMAGE BLOCK -->
				<div class="col-lg-6">
					<div class="about-img text-center wow fadeInUp" data-wow-delay="0.6s"
						style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInUp;">
						<img class="img-fluid" src="assets/images/hero-1-img.png" alt="about-image">
					</div>
				</div>


			</div> <!-- End row -->
		</div> <!-- End container -->
	</section>


	<section id="banner-2" class="banner-section division">
		<div class="bg-scroll bg-inner bg-image division">
			<div class="container white-color">
				<div class="row d-flex align-items-center p-5">

					<!-- BANNER TEXT -->
					<div class="col-12 offset-lg-1">
						<div class="banner-txt pc-30 wow fadeInUp" data-wow-delay="0.4s"
							style="visibility: visible; animation-delay: 0.4s; animation-name: fadeInUp;">

							<!-- Section ID -->
							<span class="section-id id-color">Modern Medicine</span>

							<!-- Title  -->
							<h3 class="h3-lg">Better Technologies for Better Healthcare</h3>

							<!-- Text -->
							<p>We use the latest medical technologies to ensure accurate diagnosis and effective treatment.
								Our advanced tools help deliver faster results, safer procedures, and improved patient care
							</p>

							<!-- Button -->
							<a href="all-doctors.html" class="btn btn-tra-white blue-hover">View Our Doctors</a>

						</div>
					</div> <!-- END BANNER TEXT -->


				</div> <!-- End row -->
			</div> <!-- End container -->
		</div> <!-- End Inner Background -->
	</section>
</div>